export const developConfig = {
	environment: {
		name: 'development',
		apiBasePath: 'https://localhost:44368/',
		region: 'EU',
		jwtTokenCheckIntervalTime: 1800000
	},
	auth0: {
		domain: 'signin-test.allocate-cloud.co.uk',
		clientId: 'yfMEP0UMUFs7SjVA1HofbTnAQ4qgCgiD',
		redirectUri: 'https://localhost:44366/',
		audience: 'https://reporting-api-development.allocate-dev.co.uk/',
		maxAge: 7200
	},
	grid: {
		valuesLoadIntervalMs: 1500,
		cellResetWaitTimeMs: 45000,
		cellResultThresholdWaitTime: 35000
	},
	analysisSettings: {
		maxNumberOfAdditionalChartMetrics: 3
	}
};

export const defaultConfigPath = '../config.json';

class GlobalConfiguration {
	configuration = developConfig;

	configured = false;

	get() {
		if (this.configured) {
			return this.configuration;
		}

		throw new Error(
			'Global configuration has not been defined yet. Be sure to call the getter only after the config has been downloaded and set. Probable cause is accessing globalConfig in static context.'
		);
	}

	set(value) {
		if (!this.configured) {
			this.configuration = value;
			this.configured = true;
		} else {
			throw new Error(
				'Global config has already been defined and now has been called second time. This is probably not intended.'
			);
		}
	}
}

export const globalConfig = new GlobalConfiguration();
